import { useOutletContext } from "react-router-dom";
import type { MemberInfo } from "./useMember";

export interface SignedInContext {
  status: "signed-in";
  email: string;
  member: MemberInfo;
}

/** Only valid inside <ProtectedLayout>'s <Outlet> — it always passes this shape. */
export function useSignedInContext(): SignedInContext {
  return useOutletContext<SignedInContext>();
}
